import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import { AccessData } from "./Access.model";
import { useQuery } from "react-query";

export function useAccessApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getAccess: async () => apiResolver<AccessData>(api.get("/gateway/access")),
    }),
    [api]
  );
}

export function useGetAccess(enabled: boolean = true) {
  const { getAccess } = useAccessApi();

  return useQuery({
    queryKey: "access",
    queryFn: () => getAccess(),
    enabled,
  });
}